/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { WeatherUmbrellaIcon16Light } from './WeatherUmbrellaIcon16Light';
import { WeatherUmbrellaIcon16Regular } from './WeatherUmbrellaIcon16Regular';
import { WeatherUmbrellaIcon16Solid } from './WeatherUmbrellaIcon16Solid';
import { WeatherUmbrellaIcon20Light } from './WeatherUmbrellaIcon20Light';
import { WeatherUmbrellaIcon20Regular } from './WeatherUmbrellaIcon20Regular';
import { WeatherUmbrellaIcon20Solid } from './WeatherUmbrellaIcon20Solid';
import { WeatherUmbrellaIcon24Regular } from './WeatherUmbrellaIcon24Regular';
import { WeatherUmbrellaIcon24Solid } from './WeatherUmbrellaIcon24Solid';
import { WeatherUmbrellaIcon32Regular } from './WeatherUmbrellaIcon32Regular';
import { WeatherUmbrellaIcon64Regular } from './WeatherUmbrellaIcon64Regular';
var sizes = {
    16: {
        light: WeatherUmbrellaIcon16Light,
        regular: WeatherUmbrellaIcon16Regular,
        solid: WeatherUmbrellaIcon16Solid,
    },
    20: {
        light: WeatherUmbrellaIcon20Light,
        regular: WeatherUmbrellaIcon20Regular,
        solid: WeatherUmbrellaIcon20Solid,
    },
    24: {
        regular: WeatherUmbrellaIcon24Regular,
        solid: WeatherUmbrellaIcon24Solid,
    },
    32: {
        regular: WeatherUmbrellaIcon32Regular,
    },
    64: {
        regular: WeatherUmbrellaIcon64Regular,
    },
};
export var WeatherUmbrellaIcon = forwardRef('WeatherUmbrellaIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
